<p-dialog
    [(visible)]="visible"
    modal="true"
    [header]="'service.settings.general.doctorRecordType.label' | translate"
>
    <div class="flex gap-large pt-5">
        <app-check-input [form]="form" id="active"
            [label]="'service.settings.general.doctorRecordType.fields.active' | translate"></app-check-input>
        <app-text-input [form]="form" id="name"
            label="service.settings.general.doctorRecordType.fields.name"
        ></app-text-input>
        <app-multi-select-input
            class="hotFixHeight"
            style="min-width: 100px;"
            [zIndex]="1003"
            [form]="form"
            id="procedures"
            label="service.settings.general.doctorRecordType.fields.procedures"
            [infiniteScroll]="store.procedures()"
            valueKey="code"
            labelKey="code"
        >
            <ng-template #item let-item>
                {{ item | formatServiceProcedure }}
            </ng-template>
            <ng-template #selectedItems let-items>
                <app-performed-procedures
                    [procedures]="items | transformSingleServiceProcedures"></app-performed-procedures>
            </ng-template>
        </app-multi-select-input>
        <app-text-input [form]="form" id="description"
            label="service.settings.general.doctorRecordType.fields.description"
        ></app-text-input>
    </div>

    <ng-template pTemplate="footer">
        <app-action-buttons (primaryClickEvent)="submit()" (secondaryClickEvent)="show(false)"></app-action-buttons>
    </ng-template>
</p-dialog>
